import { FloorplanFreeText } from "@domain/project/floorplan/floorplan-free-text";
import { TableColumn } from "@pdf/helpers/default-table/table-column";
import { Headlines, ImagePaths, TableProperties } from "@pdf/pdf-properties";
import { jsPDF } from "jspdf";
import { FloorplanInformationTable } from "../floorplan-information-table";
import { FreeTextsRow } from "./free-texts-row";

export class FloorplanFreeTextsRowHeaders {
  public readonly NUMBER: string = $localize`:@@pdfExport.freeTextsTable.header.number:Nr.`;
  public readonly DISPLAY_NAME: string = $localize`:@@pdfExport.freeTextsTable.header.displayName:Anzeigename`;
  public readonly CONTENT: string = $localize`:@@pdfExport.freeTextsTable.header.content:Inhalt`;
}

export class FreeTextsTable extends FloorplanInformationTable {
  readonly headlines = new Headlines();
  readonly rowHeaders = new FloorplanFreeTextsRowHeaders();
  override readonly headline = this.headlines.FREE_TEXTS;
  override readonly columns: TableColumn[];
  override readonly rows: FreeTextsRow[];

  constructor(pdf: jsPDF, floorplanFreeTexts: FloorplanFreeText[]) {
    super(ImagePaths.NOTE);
    this.columns = [
      new TableColumn(this.rowHeaders.NUMBER, 60, 96),
      new TableColumn(this.rowHeaders.DISPLAY_NAME, 180, 156),
      new TableColumn(this.rowHeaders.CONTENT, 360, 1104),
    ];

    this.rows = floorplanFreeTexts.map(
      (floorplanText) =>
        new FreeTextsRow(
          pdf,
          this.textToColumnWidth(
            pdf,
            TableProperties.TEXT_FONT_SIZE,
            this.preProcessText(floorplanText.positionId),
            this.rowHeaders.NUMBER,
          ),
          this.textToColumnWidth(
            pdf,
            TableProperties.TEXT_FONT_SIZE,
            this.preProcessText(floorplanText.displayName),
            this.rowHeaders.DISPLAY_NAME,
          ),
          this.textToColumnWidth(
            pdf,
            TableProperties.TEXT_FONT_SIZE,
            this.preProcessText(floorplanText.content),
            this.rowHeaders.CONTENT,
          ),
        ),
    );
    this.height = this.calculateHeight(this.rows);
  }
}
